import React from "react";
import { useTranslation } from "react-i18next";
import EAAlert from "../../../shared/EAAlert";

interface BasketSurveyAlertsProps {
  hasValidationErrors: boolean;
  surveySaveError: boolean;
}

const BasketSurveyAlerts: React.FC<BasketSurveyAlertsProps> = ({
  hasValidationErrors,
  surveySaveError,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {hasValidationErrors && (
        <EAAlert type="error" message={t("nie_wypelniono_wymaganych_pol")} />
      )}
      {surveySaveError && <EAAlert type="error" message={t("blad_zapisu_ankiety")} />}
    </>
  );
};

export default BasketSurveyAlerts;
